<template>
  <div>
    <section class="section-kl-bg section-slogan d-flex align-items-stretch">
      <div class="container d-flex flex-column align-items-center mt-6">
        <div class="row flex-1 align-items-center">
          <div class="col-12 section-kl-bg-content text-center mw-53 mx-auto">
            <h1 class="heading2 text-white text-uppercase">Konto Librus</h1>
            <p class="body1 text-white">
              Codzienne wsparcie w nauce, monitorowaniu edukacji dziecka, pracy
              w szkole, komunikacji, a nawet rozwoju osobistym! Dla rodziców,
              uczniów, nauczycieli i innych pracowników szkoły.
            </p>

            <a
              href="https://portal.librus.pl/konto-librus/register"
              class="btn btn-default btn-cta text-uppercase"
              >Załóż bezpłatne konto</a
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="caption text-white my-4">
              Część usług oferowanych w ramach Konta LIBRUS dostępna jest po
              jego połączeniu z kontem w systemie Synergia. Szczegóły dostępne w
              <a
                href="https://portal.librus.pl/rodzina/regulamin"
                rel="noopener noreferrer"
                target="_blank"
                >Regulaminie świadczenia usługi</a
              >
              i
              <a
                href="https://www.librus.pl/artykuly/polityka-prywatnosci/"
                rel="noopener noreferrer"
                target="_blank"
                >Polityce prywatności.</a
              >
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section-white phone-section">
      <div class="container py-0">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-12 text-lg-left text-center">
            <h2 class="heading3 text-uppercase" style="color: #619bc4">
              Wszystko pod ręką!
            </h2>
            <p class="subtitle4">
              Załóż Konto LIBRUS i korzystaj <br />
              w dowolnym miejscu i czasie
            </p>
            <div class="text-lg-left text-sm-center text-left px-4 px-sm-0">
              <p class="subtitle1--bold mb-0" style="color: #619bc4">
                Aplikacja Librus
              </p>
              <p class="body2">wygodnie przeglądaj informacje o uczniu</p>
            </div>
            <div class="text-lg-left text-sm-center text-left px-4 px-sm-0">
              <p class="subtitle1--bold mb-0" style="color: #619bc4">
                Aplikacja Librus Nauczyciel
              </p>
              <p class="body2">sprawnie organizuj swoją pracę</p>
            </div>
            <div class="text-lg-left text-sm-center text-left px-4 px-sm-0">
              <p class="subtitle1--bold mb-0" style="color: #619bc4">
                Akademia Librus
              </p>
              <p class="body2">skutecznie rozwijaj kompetencje zawodowe</p>
            </div>
          </div>
          <div
            class="col-lg-5 col-md-12 phone-image-wrapper position-relative mt-5 mt-lg-0 overflow-hide"
          >
            <img
              src="../assets/images/foto/wszystko-pod-reka.png"
              class="internal-image"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="section-light-blue position-relative card-section">
      <div class="container card-container">
        <div class="row kl-card">
          <div
            class="col-12 col-lg-6 text-lg-left text-center bg-white kl-card-text"
          >
            <h2 class="heading3 text-uppercase">
              Aplikacja <br />
              Librus
            </h2>
            <p class="subtitle1">dla rodziców i uczniów</p>
            <a href="/aplikacjamobilna">
              <button class="btn btn-cta text-uppercase">
                Sprawdź, co zyskasz
              </button>
            </a>
          </div>
          <div class="col-12 col-lg-6 px-0 overflow-hide">
            <img
              src="../assets/images/foto/aplikacja-librus_rodzice.png"
              class="internal-image"
              style="width: 100%"
            />
          </div>
        </div>
        <div class="row flex-column-reverse flex-lg-row mb-5">
          <div class="col-12 col-lg-6 px-0 overflow-hide">
            <img
              src="../assets/images/foto/aplikacja-librus_nauczyciel.png"
              class="internal-image"
              style="width: 100%"
            />
          </div>
          <div
            class="col-12 col-lg-6 text-lg-left text-center bg-white kl-card-text"
          >
            <h2 class="heading3 text-uppercase">
              Aplikacja <br />
              Librus nauczyciel
            </h2>
            <p class="subtitle1">dla pracowników szkół</p>
            <a href="/nauczyciel">
              <button class="btn btn-cta text-uppercase">
                Zobacz, jak Cię wesprze
              </button>
            </a>
          </div>
        </div>
        <div class="row flex-column-reverse flex-lg-row-reverse">
          <div class="col-12 col-lg-6 px-0 overflow-hide">
            <img
              src="../assets/images/foto/aplikacja-akademia_librus.png"
              class="internal-image"
              style="width: 100%"
            />
          </div>
          <div
            class="col-12 col-lg-6 text-lg-left text-center bg-white kl-card-text"
          >
            <h2 class="heading3 text-uppercase">Akademia Librus</h2>
            <p class="subtitle1">dla pracowników szkół</p>
            <a href="https://akademia.librus.pl/szkolenia">
              <button class="btn btn-cta text-uppercase">
                Poznaj szkolenia
              </button>
            </a>
          </div>
        </div>
        <div class="text-center kl-cards-desc">
          <p class="heading4 text-white mx-auto" style="max-width: 1030px">
            Przekonaj się, jak szybko i sprawnie założyć Konto LIBRUS i
            korzystać z powyższych usług!
          </p>
        </div>
        <div class="text-center">
          <a
            href="/pomoc/konto-librus"
            rel="noopener noreferrer"
            target="_blank"
            class="btn btn-outline-light text-uppercase mx-3 mt-3 mt-md-0"
          >
            Przejdź do pomocy
          </a>
        </div>
      </div>
    </section>
    <section class="section-white">
      <div class="container">
        <div class="row my-4">
          <div class="col-12 text-center">
            <h2 class="heading3 text-uppercase">
              Zacznij korzystać z Konta LIBRUS
            </h2>
            <p class="mt-4 subtitle1">Założenie konta zajmie tylko chwilę</p>
            <a
              href="https://rodzina.librus.pl"
              class="btn btn-default btn-cta mt-4 text-uppercase"
              style="width: 260px"
              >Załóż konto!</a
            >
          </div>
        </div>
      </div>
    </section>
    <section class="section-grey py-4">
      <div class="container text-center">
        <p class="caption2 mb-1">
          Aplikacja Librus dostępna jest w 4 wariantach, które różnią się liczbą
          funkcji. Wariant podstawowy jest bezpłatny, Plan SMART DODATKI i
          warianty Mobilnych dodatków są płatne. Działanie poszczególnych
          funkcji aplikacji Librus (niezależnie od wariantu) oraz aplikacji
          Librus Nauczyciel może być uzależnione od ich wykorzystania przez
          szkołę.
        </p>
        <p class="caption2 mb-1">
          Dodatkowo aplikacja Librus dla oddziałów przedszkolnych ma inny zakres
          funkcji niż wersja dla szkół. Szczegółowy zakres modułów i funkcji
          dostępny w aplikacji dla szkół i oddziałów przedszkolnych znajduje się
          na
          <a href="/aplikacjamobilna" target="_blank" rel="noopener noreferrer"
            >stronie aplikacji Librus</a
          >.
        </p>
        <p class="caption2 mb1-">
          Usługa Natychmiastowe powiadomienia w aplikacji mobilnej Librus i
          Librus Nauczyciel jest świadczona na wybranych platformach mobilnych
          zgodnie z zapisami
          <a href="/regulaminy" target="_blank" rel="noopener noreferrer"
            >Regulaminu świadczenia usługi</a
          >.
        </p>
        <p class="caption2 mb-0">
          Część usług oferowanych w ramach Konta LIBRUS dostępna jest po jego
          powiązaniu z kontem w systemie Synergia. Szczegóły dostępne w
          <a href="/regulaminy" rel="noopener noreferrer" target="_blank"
            >Regulaminie świadczenia usługi</a
          >
          i
          <a
            href="https://www.librus.pl/artykuly/polityka-prywatnosci/"
            rel="noopener noreferrer"
            target="_blank"
            >Polityce prywatności</a
          >.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "KontoLibrus",
  created() {
    this.$emit("showFaqHeader", false);
  },
  mounted() {
    document.title = "Konto LIBRUS";
  },
};
</script>
<style scoped>
.flex-bottom {
  align-items: flex-end;
}
.list-margin {
  margin-left: 20px;
}
</style>
